<template>
  <div class="soc-change" ref="socChangeRef">

  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, useTemplateRef, watch } from 'vue';
import * as echarts from 'echarts';

const socChangeRef = useTemplateRef('socChangeRef');

const props = defineProps({
  startSoc: {
    type: Number,
    required: true,
  },
  endSoc: {
    type: Number,
    required: true,
  },
})

const clampSoc = value => Math.max(0, Math.min(100, Number(value) || 0));

const renderChart = () => {
  if (!socChangeRef.value) return;
  const startSoc = clampSoc(props.startSoc);
  const endSoc = clampSoc(props.endSoc);


  var width = socChangeRef.value.clientWidth;
  var height = socChangeRef.value.clientHeight;
  var cx = width / 2;
  var cy = height / 2;
  
  // const startSOC = 80;
  // const endSOC = 60;




  // /////////////////////////////////////////////////////////////
  const rect = { width: 30, height: 50, r: 6 };
  const smallRect = { width: 15, height: 5, r: 5 };
  const startX = cx - rect.width / 2;
  const startY = cy - rect.height / 2;

  const isCharge = startSoc < endSoc;
  const maxSOC = Math.max(startSoc, endSoc);
  const batteryStyle = isCharge ? { fill: '#B6E633', stroke: '#000' } : { fill: '#FEAEC9', stroke: '#000' };

  const diffSOC = Math.abs(startSoc - endSoc);

  const isNear100 = Math.abs(maxSOC - 100) < 1;

  const chart = echarts.init(socChangeRef.value);
  chart.setOption({
    graphic: [
        {
          // battery background
          type: 'rect',
          silent: true,
          shape: { x: cx - rect.width / 2, y: cy - rect.height / 2, width: rect.width, height: rect.height, r: rect.r },
          style: { fill: '#fff', stroke: '#000', },
        },
        {
          // small rect
          type: 'rect',
          silent: true,
          shape: { x: cx - smallRect.width / 2, y: 0, width: smallRect.width, height: smallRect.height, r: smallRect.r },
          style: { fill: '#D6D6D6', stroke: '#000' },
        },
        {
          // max rect
          type: 'rect',
          silent: true,
          shape: { x: startX, y: startY + (rect.height - rect.height * maxSOC / 100), width: rect.width, height: rect.height * maxSOC / 100, r: [isNear100 ? rect.r : 0, isNear100 ? rect.r : 0, rect.r, rect.r] },
          style: batteryStyle
        },
        {
          // diff rect
          type: 'rect',
          silent: true,
          shape: { x: startX, y: startY + (rect.height - rect.height * maxSOC / 100), width: rect.width, height: rect.height * diffSOC / 100, r: [isNear100 ? rect.r : 0, isNear100 ? rect.r : 0, diffSOC == maxSOC ? rect.r : 0, diffSOC == maxSOC ? rect.r : 0] },
          style: { fill: 'rgba(82,82,82, 0.3)', stroke: '#000' },
        }

      ],
  });

};

onMounted(() => {
  renderChart();
});

watch(
  () => [props.startSoc, props.endSoc],
  () => {
    renderChart();
  }
);



</script>

<style scoped>
.soc-change {
  width: 80px;
  height: 60px;
  /* border: 1px solid red; */
}
</style>
